import React from 'react';

const SponsorFocus = (props) => {
    return (
        <div className="content-body-widget-main sponsor-focus">
            <div className="db-box widget-box">

                <div className="db-header">
                    <div>
                        <div>About the Sponsor</div>
                    </div>
                </div>

                <div className="sponsor-logo">
                    <img
                        className="img-fluid"
                        src={props.img}
                        alt={props.imgAlt}
                    />
                </div>
                <p>{props.text}</p>

            </div>
        </div>
    )
}

export default SponsorFocus;
